var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoCepas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.24 37.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ed008e;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo cepas") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.09,35.34H2v.51H3.55a1.53,1.53,0,1,1-1.5-1.79,1.52,1.52,0,0,1,1.08.45l0,0,0,0c.32-.3.32-.3.32-.33v0l0,0a2,2,0,0,0-1.46-.6A2.05,2.05,0,1,0,4.1,35.59c0-.06,0-.11,0-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.26,34.72a1.13,1.13,0,0,0-1.12-1.12H4.55v4h.52V35.84h.82l.84,1.75h.56l-.84-1.79a1.11,1.11,0,0,0,.81-1.07m-.5,0a.63.63,0,0,1-.63.62H5.07V34.09H6.13a.63.63,0,0,1,.63.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.17,36A1.08,1.08,0,1,1,8,36V33.59H7.48V36a1.61,1.61,0,1,0,3.21,0V33.59h-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.73,33.59H11.14v4h.52V35.84h1.06a1.12,1.12,0,1,0,0-2.24m.63,1.13a.63.63,0,0,1-.63.62H11.67V34.09h1.06a.63.63,0,0,1,.63.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,33.54a2.05,2.05,0,1,0,2.05,2.05A2.05,2.05,0,0,0,16,33.54m1.53,2.05A1.53,1.53,0,1,1,16,34.06a1.53,1.53,0,0,1,1.53,1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.57,34.51s0,0,.36-.3l0,0,0,0a2,2,0,0,0-1.45-.6A2.05,2.05,0,1,0,23.93,37l0,0-.33-.34,0,0,0,0a2.69,2.69,0,0,1-1.08.45,1.53,1.53,0,1,1,1-2.64h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "24.18 37.59 27.04 37.59 27.04 37.09 24.71 37.09 24.71 35.84 26.62 35.84 26.62 35.34 24.71 35.34 24.71 34.09 27.04 34.09 27.04 33.59 24.18 33.59 24.18 37.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30,34.72a1.13,1.13,0,0,0-1.12-1.12H27.26v4h.52V35.84h1.06A1.12,1.12,0,0,0,30,34.72m-.5,0a.63.63,0,0,1-.63.62H27.79V34.09h1.06a.63.63,0,0,1,.63.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.55,33.6H31l-1.43,4h.56l.42-1.16H32l.42,1.16H33l-1.41-4Zm.27,2.33H30.75l.54-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.51,35.35l-.67-.2a.51.51,0,0,1-.39-.49.6.6,0,0,1,.64-.57.66.66,0,0,1,.6.33l0,0,0,0a1.7,1.7,0,0,0,.39-.17l0,0,0,0a1.15,1.15,0,0,0-1.06-.65,1.12,1.12,0,0,0-1.16,1.09,1,1,0,0,0,.71,1l.7.22a.59.59,0,0,1,.45.57.68.68,0,0,1-.7.67.7.7,0,0,1-.64-.4l0,0-.48.21,0,0a1.22,1.22,0,0,0,1.12.71,1.2,1.2,0,0,0,1.22-1.18,1.12,1.12,0,0,0-.8-1.08"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 36.92,
    y: 33.48,
    width: 0.27,
    height: 1.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.06,34.79a.18.18,0,0,0-.15.08H40V33.48H38.24v1.13l-.66-1.12h-.27v1.67h.27V34l.66,1.13h.35l-.07-.08V33.76H39v1.39h.27V33.76h.46v1.39h1.21v0a.18.18,0,0,0,.13.06.18.18,0,0,0,0-.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.48,23.86a13.6,13.6,0,0,1-14.35,2.69,12.92,12.92,0,0,1-7.72-8.21A13.54,13.54,0,0,1,20.25.51,13.4,13.4,0,0,1,29.41,4.1a.29.29,0,0,1,0,.41L26.52,7.4a.28.28,0,0,1-.39,0,9,9,0,0,0-8.66-2,8.86,8.86,0,0,0-6.18,6.47,9,9,0,0,0,14.88,8.75.29.29,0,0,1,.4,0l2.93,2.86a.29.29,0,0,1,0,.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.59,0A1.19,1.19,0,1,1,30.4,1.19,1.19,1.19,0,0,1,31.59,0m0,2.16a1,1,0,1,0-1-1,1,1,0,0,0,1,1m.57-.32h-.22l-.32-.44h-.27v.44h-.21V.57h.59a.41.41,0,0,1,.41.41.42.42,0,0,1-.29.39Zm-.44-.65a.21.21,0,0,0,.21-.2.21.21,0,0,0-.21-.21h-.38v.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.37,16.38l-6.54.93a.8.8,0,0,1-.22,0l-6.4-.93a.2.2,0,0,1-.17-.2V11.87a.2.2,0,0,1,.2-.2h13.1a.2.2,0,0,1,.2.2v4.31a.2.2,0,0,1-.17.2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCepas);
export default __webpack_public_path__ + "static/media/logo-cepas.dee58ae0b722667cb4ddfde60eb60716.svg";
export { ForwardRef as ReactComponent };